/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line import/prefer-default-export
/* eslint-disable no-nested-ternary */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/ban-ts-ignore */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/prefer-default-export */
import _ from 'lodash';
import latinize from 'latinize';
import routerLoader from '../i18n/router';
import { AuthContextType } from '../types/Types';
// eslint-disable-next-line import/no-cycle
import { AppContextType } from '../store/AppContext';
import { getCookies } from '../api/api';
import GtmService from '../services/GtmService';
import { GtmConstants } from './GtmConstants';
import { HostProvider } from './HostProvider';
import { GTMLayerData } from '../types/GTMLayer';
import { MobileUtils } from './MobileUtils';

export class GtmManager {
  static sendPageInfoGtm = (
    category: string,
    dataApp: AppContextType,
    dataUser: AuthContextType,
    ipValue: string,
  ) => {
    // @ts-ignore
    window.dataLayer = [];

    if (HostProvider.isCaprabo()) {
      // @ts-ignore
      window.dataLayer.push({
        page_level_1: dataApp.levels[0],
        page_level_2: dataApp.levels[1],
        page_level_3: dataApp.levels[2],
        page_app_club:
          dataUser.user.isApp && dataUser.user.isApp === 'true' ? '1' : '0',
        page_app_cac: '1',
        user_login_submit: '1',
        user_id: dataUser.user.idShopper.toString(),
        user_id_mdm:
          dataUser.user.idHub !== null
            ? dataUser.user.idHub.toString()
            : 'none',
        user_account_type: GtmManager.getAccountTypeDatalayer(dataUser),
        user_register_date: dataUser.user.fechaRegistro,
        user_birth_date: dataUser.user.fechaNacimiento,
        user_gender: GtmManager.getUserGender(dataUser),
        user_postal_code: dataUser.user.postalCode,
        user_club_type: GtmManager.getCapraboClubTypeDatalayer(dataUser),
        user_club_card_number: dataUser.user.card,
        user_goldcard: dataUser.user.oroType,
        user_store: dataUser.user.store,
        user_sociodemo_segment: dataUser.user.codSegSocioDemo,
        user_savings_segment: dataUser.user.codInteresahorro,
        user_loyalty_segment: dataUser.user.codSegGFidelidad,
        user_zone_segment: dataUser.user.codInteresLocal,
        user_health_segment: dataUser.user.codInteresSalud,
      });
    } else {
      const commerce = sessionStorage.getItem('isEcommerceBot');
      // GtmConstants.AC_TYPE, category
      // @ts-ignore
      window.dataLayer.push({
        page_level_1: dataApp.levels[0],
        page_level_2: dataApp.levels[1],
        page_level_3: dataApp.levels[2],
        page_web_ecommerce_bot: _.isNull(commerce) ? '0' : commerce,
        page_app_club:
          dataUser.user.isApp && dataUser.user.isApp === 'true' ? '1' : '0',
        user_login_submit: '1',
        user_id: dataUser.user.idShopper.toString(),
        user_id_mdm:
          dataUser.user.idHub !== null
            ? dataUser.user.idHub.toString()
            : 'none',
        user_account_type: GtmManager.getAccountTypeDatalayer(dataUser),
        user_register_date: dataUser.user.fechaRegistro,
        user_birth_date: dataUser.user.fechaNacimiento,
        user_gender: GtmManager.getUserGender(dataUser),
        user_postal_code: dataUser.user.postalCode,
        user_club_type: GtmManager.getEroskiClubTypeDatalayer(dataUser),
        user_club_card_number: dataUser.user.card,
        user_travel_member: dataUser.user.travelMember,
        user_goldcard: dataUser.user.oroType,
        user_mastercard: dataUser.user.tarjetaMasterCard,
        user_store: dataUser.user.store,
        user_sociodemo_segment: dataUser.user.codSegSocioDemo,
        user_savings_segment: dataUser.user.codInteresahorro,
        user_loyalty_segment: dataUser.user.codSegGFidelidad,
        user_zone_segment: dataUser.user.codInteresLocal,
        user_health_segment: dataUser.user.codInteresSalud,
      });
    }
    dataApp.changeGtmFlag(true);
  };

  static sendUpgradeNoroGTM = (
    dataUser: AuthContextType,
    dataApp: AppContextType,
    label: string,
    ipValue: string,
  ) => {
    GtmManager.sendSimpleGTMEventAndSaveIt(
      dataUser,
      dataApp,
      GtmConstants.UPGRADE_CATEGORY,
      GtmConstants.NORO_ACTION,
      label,
      ipValue,
    );
  };

  static sendHeaderLinkClickGTM = (label: string) => {
    GtmManager.sendSimpleGTMEvent(
      GtmConstants.ARE_CLIENTE_CATEGORY,
      GtmConstants.LINK_CABECERA_ACTION,
      label,
    );
  };

  static sendActivarOroGTM = (
    request: string,
    category: string,
    cuota: string,
    step: string,
    label: string,
  ) => {
    GtmManager.sendChangeGTMEvent(request, category, cuota, step, label);
  };

  static sendActivarValeGTM = (label: string) => {
    GtmManager.sendSimpleGTMEvent(
      GtmConstants.CUPONES_CATEGORY,
      GtmConstants.ACTIVAR_VALE_ACTION,
      label,
    );
  };

  static sendAComportamientoEvent = (dataGTM: GTMLayerData, label = '') => {
    GtmManager.sendComportamientoGTMEvent(dataGTM, label);
  };

  static sendMenuLinkClickGTM = (label: string) => {
    GtmManager.sendSimpleGTMEvent(
      GtmConstants.ARE_CLIENTE_CATEGORY,
      GtmConstants.MENU_ACTION,
      label,
    );
  };

  static sendLogoutGTM = (
    dataUser: AuthContextType,
    dataApp: AppContextType,
    action: string,
    label: string,
    ipValue: string,
  ) => {
    GtmManager.sendSimpleGTMEventAndSaveIt(
      dataUser,
      dataApp,
      GtmConstants.LOGOUT,
      action,
      label,
      ipValue,
    );
  };

  private static sendSimpleGTMEvent = (
    category: string,
    action: string,
    label: string,
  ) => {
    const correctedLabel = label === '' || label === undefined ? 'web' : label;
    // @ts-ignore
    window.dataLayer = window.dataLayer || [];
    // @ts-ignore
    window.dataLayer.push({
      event: GtmConstants.EVENT,
      gaEventCategory: category,
      gaEventAction: action,
      gaEventLabel: correctedLabel,
      gaEventValue: '',
      gaEventNonInteration: GtmConstants.FALSE,
    });
  };

  private static sendChangeGTMEvent = (
    request: string,
    categoryStr: string,
    cuota: string,
    step: string,
    label: string,
  ) => {
    const correctedLabel =
      label === '' || label === undefined ? 'web' : label.toLowerCase();
    // @ts-ignore
    window.dataLayer = window.dataLayer || [];
    // @ts-ignore
    window.dataLayer.push({
      event: request,
      category: categoryStr,
      subcategory: cuota,
      step: step,
      click_name: correctedLabel,
    });
  };

  private static sendComportamientoGTMEvent = (
    data: GTMLayerData,
    label = '',
  ) => {
    const gtmdata = { ...data }; // decouple instance
    const correctedLabel = label === '' ? gtmdata.click_name : label;
    // @ts-ignore
    window.dataLayer = window.dataLayer || [];
    gtmdata.click_title = GtmManager.cleanLabelstr(gtmdata.click_title);
    gtmdata.click_name = GtmManager.cleanLabelstr(correctedLabel);
    // @ts-ignore
    window.dataLayer.push(gtmdata);
  };

  private static cleanLabelstr(lbel = '') {
    return latinize(lbel).toLowerCase();
  }

  private static sendSimpleGTMEventAndSaveIt = (
    dataUser: AuthContextType,
    dataApp: AppContextType,
    category: string,
    action: string,
    label: string,
    ipValue: string,
  ) => {
    const correctedLabel = label === '' || label === undefined ? 'web' : label;
    GtmManager.sendSimpleGTMEvent(category, action, label);
    const dataForLog = GtmManager.getGtmSimplePojo(
      dataApp,
      dataUser,
      category,
      action,
      GtmManager.cleanLabelstr(correctedLabel),
      ipValue,
    );
    GtmManager.saveLogGTM(dataForLog);
  };

  private static saveLogGTM = (dataLog: any) => {
    GtmService.sendGtm(dataLog);
  };

  private static getGtmSimplePojo = (
    dataApp: AppContextType,
    dataUser: AuthContextType,
    category: string,
    action: string,
    label: string,
    ipValue: string,
  ) => {
    const url = window.location.pathname.split('/');
    const fromUrl = routerLoader.LoadRouterByPath(url[2], dataApp.lang);
    const isApp = dataUser.user.isApp === 'true';
    const fromApp = isApp ? 'app_club' : 'web';
    const { email } = dataUser.user;
    const hayTagManager =
      // @ts-ignore
      typeof window.google_tag_manager === 'object' ? '1' : '0';
    return {
      category,
      action,
      label,
      email,
      fromApp,
      fromUrl,
      jsessionid: getCookies().get('JSESSIONID'),
      enviado: hayTagManager,
      ip: ipValue,
    };
  };

  private static getAccountTypeDatalayer = (dataUser: AuthContextType) => {
    return dataUser.user.isEmpresa
      ? 'E'
      : dataUser.user.isGibraltar
      ? 'G'
      : 'P';
  };

  private static getEroskiClubTypeDatalayer = (dataUser: AuthContextType) => {
    return dataUser.user.titular ? 'T' : dataUser.user.coTitular ? 'C' : 'none';
  };

  private static getCapraboClubTypeDatalayer = (dataUser: AuthContextType) => {
    return dataUser.user.adicional ? 'A' : dataUser.user.titular ? 'P' : 'none';
  };

  private static getUserGender = (dataUser: AuthContextType) => {
    if (
      dataUser.user.gender !== null &&
      dataUser.user.gender !== undefined &&
      dataUser.user.gender.trim() !== '' &&
      dataUser.user.gender.trim() !== 'undefined'
    ) {
      return dataUser.user.gender;
    }

    return 'none';
  };

  static createHeadScript = (dataUser: AuthContextType) => {
    const isCaprabo = HostProvider.isCaprabo();

    let scriptGtm = document.getElementById('gtm_script');
    if (scriptGtm) {
      scriptGtm.remove();
    }
    const noStrustScript =
      _.isNull(document.getElementById('trust_script')) &&
      _.isNull(document.getElementById('trust_function'));
    const scriptCaprabo = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-KSLWGFK7');`;
    const scriptEroski = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-M7M63B7');`;
    const innerHtmlGtm = isCaprabo ? scriptCaprabo : scriptEroski;
    const fnctionScript = 'function OptanonWrapper() {}';

    if (dataUser.user.trustApp && noStrustScript) {
      const scritTrust = GtmManager.setOneTrustByAplication(
        isCaprabo,
        dataUser.user.isApp,
      );
      // @ts-ignore
      document.getElementsByTagName('head')[0].appendChild(scritTrust);

      const scriptTrustFunction = document.createElement('script');
      scriptTrustFunction.id = 'trust_function';
      scriptTrustFunction.type = 'text/javascript';
      scriptTrustFunction.innerHTML = fnctionScript;
      document.getElementsByTagName('head')[0].appendChild(scriptTrustFunction);
    }
    scriptGtm = document.getElementById('gtm_script');

    if (!scriptGtm) {
      const script = document.createElement('script');
      script.id = 'gtm_script';
      script.type = 'text/javascript';
      script.innerHTML = innerHtmlGtm;
      document.getElementsByTagName('head')[0].appendChild(script);
    }
  };

  private static setOneTrustByAplication(
    isCaprabo: boolean,
    isApp: string | undefined,
  ) {
    const scritTrust = document.createElement('script');
    scritTrust.id = 'trust_script';
    scritTrust.type = 'text/javascript';
    const app = isApp === 'true';
    const excludedOneTrust = app && MobileUtils.isIosMobile();

    if (excludedOneTrust) {
      scritTrust.src = '';
      return scritTrust;
    }
    if (isCaprabo) {
      scritTrust.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
      scritTrust.setAttribute(
        'data-domain-script',
        'b2fde5ec-51de-4ec8-a03a-c02d12f3bbe3-test',
      );
      scritTrust.setAttribute('data-document-language', 'true');
    } else {
      scritTrust.src =
        'https://cdn.cookielaw.org/consent/4ad5a107-ec48-4bf7-b4cd-70559698027d/otSDKStub.js';
      scritTrust.setAttribute(
        'data-domain-script',
        '4ad5a107-ec48-4bf7-b4cd-70559698027d',
      );
    }
    return scritTrust;
  }
}
